import LegacyPicture from '@uikit/components/LegacyPicture/LegacyPicture';
import clsx from 'clsx';
import styles from './MagazineCategoryHero.module.scss';
import type { MagazineCategoryHeroProps } from './interfaces';

const MagazineCategoryHero = ({
  image,
  title,
  subTitle,
  className,
}: MagazineCategoryHeroProps) => {
  return (
    <div className={clsx(styles.base, className)}>
      <div className={styles.wrapper}>
        {image && (
          <div className={styles.colImage}>
            <LegacyPicture asset={image} className={styles.image} fitCover />
          </div>
        )}
        <div className={styles.colText}>
          <h1 className={styles.title}>#{title}</h1>
          <p className={styles.subTitle}>{subTitle}</p>
        </div>
      </div>
    </div>
  );
};

export default MagazineCategoryHero;
